import React, { useEffect, useState, useCallback } from "react";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import { ErrorMessage, getIn } from "formik";
import { Select } from "formik-material-ui";

import TextError from "./TextError";

const OutlineSelect = (props) => {
  const classes = useStyles();
  const [warn, setWarn] = useState(false);
  const errorStyle = useCallback(() => {
    if (getIn(props.form.errors, props.field.name)) {
      setWarn(true);
    } else {
      setWarn(false);
    }
  }, [props.form.errors, props.field.name]);

  useEffect(() => {
    errorStyle();
  }, [errorStyle]);

  return (
    <FormControl
      className={classes.selectWrapper}
      id={props.id}
      onChange={props.onChange}
    >
      <InputLabel
        className={
          !props.disabled && warn ? classes.errorText : classes.inputLabel
        }
      >
        {props.label}
      </InputLabel>
      <Select
        {...props}
        className={
          !props.disabled && warn ? classes.errorContent : classes.selectContent
        }
        variant="outlined"
      />

      <ErrorMessage name={props.field.name} component={TextError} />
    </FormControl>
  );
};

const useStyles = makeStyles((theme) => {
  return {
    selectWrapper: {
      width: "100%",
    },
    inputLabel: {
      paddingLeft: 18,
      top: "-7px",
    },
    errorText: {
      paddingLeft: 18,
      top: "-7px",
      color: theme.palette.error.main,
    },
    selectContent: {
      width: "100%",
      borderStyle: "none",
      borderWidth: "0px",
    },
    errorContent: {
      width: "100%",
      borderColor: theme.palette.error.main,
      borderStyle: "solid",
      borderWidth: "1px",
    },
  };
});

export default OutlineSelect;
